export default __webpack_public_path__ + "static/services-details1e-53a7b4405e75929f05850c995dc75cd8.jpg";